/**
 * Trigger a browser download of a CSV string. Wraps the Blob + temporary
 * anchor pattern: server-side RPCs return CSV as text (e.g.
 * `export_buyer_requests_csv`), the page passes the string through here
 * to land it on the user's disk under the given filename.
 *
 * Note: `URL.createObjectURL` is revoked synchronously after the click
 * dispatch — modern browsers have already initiated the download by then,
 * so the revoke does not cancel it. This avoids a memory leak on multi-
 * export sessions (e.g. an admin running R19 = 5 exports/min).
 */
export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
